// node_modules
import {Button} from 'primereact/button'
import {Dialog} from 'primereact/dialog'
import React, {useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {setUnsavedChanges} from '../redux/slices/app.slice'
import MobileSidebar from './MobileSidebar'

// styles
import * as styles from "./SidebarMenu.module.css";

const SidebarMenu = ({ menuItems, title }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const isSidebarVisible = useSelector(state => state.app.sidebarVisible);
  const unsavedChanges = useSelector(state => state.app.unsavedChanges);
  
  const [showAlertDialog, setShowAlertDialog] = useState(false);
  const [link, setLink] = useState('');
  
  const checkChanges = (e, link) => {
    e.preventDefault()
    
    if(unsavedChanges) {
      setShowAlertDialog(true)
      setLink(link)
    }
    else
      navigate(link)
  }
  
  const confirmLink = () => {
    setShowAlertDialog(false)
    dispatch(setUnsavedChanges(false))
    navigate(link)
  }
  
  if(!isSidebarVisible){
    return <MobileSidebar menuItems={menuItems} title={title} />
  }
  
  return (
    <div className={`${styles.sidebar}`}>
        <div className="flex flex-column h-full">
          <h2>{title}</h2>
          
          <ul className="list-none p-0 m-0">
            {menuItems.map((menuItem) => {
              return (
                <li
                  className={`${
                    location.pathname.endsWith(menuItem.id)
                      ? styles.active
                      : styles.hover
                  }`}
                  key={menuItem.id}
                >
                  <Link
                    onClick={e=>checkChanges(e, menuItem.link)}
                    to={menuItem.link}
                    className={` flex align-items-center cursor-pointer  w-full ${
                      location.pathname.endsWith(menuItem.id)
                        ? styles.active
                        : styles.hover
                    }`}
                  >
                    <i className={`pi ${menuItem.icon}`}></i>
                    <span className="font-medium">{menuItem.title}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      
      <Dialog
        closable={false}
        header={
          <div style={{ width: "100%", textAlign: "center" }}>
            Leave page?
          </div>
        }
        visible={showAlertDialog}
        onHide={() => {
          setShowAlertDialog(false);
        }}
        footer={() => (
          <div className="flex flex-column gap-2 justify-content-end">
            <Button
              label="Leave"
              className={`p-button-success ${styles.confirmDialogBtn}`}
              onClick={confirmLink}
            />
            <Button
              label="Cancel"
              text
              className={`p-button-success ${styles.cancelDialogBtn}`}
              onClick={() => {
                setShowAlertDialog(false);
              }}
            />
          </div>
        )}
        className={`p-fluid ${styles.alertModal}`}
      >
        <div className={styles.text}>
          <span>
            Changes you made may not be saved.
          </span>
        </div>
      </Dialog>
    </div>
  );
};

export default SidebarMenu;
